module.exports = __webpack_public_path__ + "img/integralBG3.381b761a.png";